import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../../../util/classNames';
import { tokens } from '../../../../util/theme/fluent9';

export const useClassNames: () => GriffelClassNames<'outerLeftNav'> = makeStyles({
  outerLeftNav: {
    backgroundColor: tokens.colorNeutralBackground4,
  },
});
